const VCARD_MIME = 'text/vcard'
const VCF_EXT = '.vcf'

export const isVCardFile = (file: { filemime?: string; filename?: string }): boolean =>
  !!file.filemime?.toLowerCase().includes(VCARD_MIME) ||
  !!file.filename?.toLowerCase().endsWith(VCF_EXT)
